<div class="motors-summary-page">
  <tg-row>
    <tg-col>
      <h1>Your listing summary</h1>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col>
      <p>You’re almost ready to go! Here’s a summary of your listing.</p>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col lg="6" sm="12">
      <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
        >
        <motors-summary-page-vehicle-details-section></motors-summary-page-vehicle-details-section>
      </div>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col lg="6" sm="12">
      <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
        >
        <motors-summary-page-vehicle-description-section></motors-summary-page-vehicle-description-section>
      </div>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col lg="6" sm="12">
      <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
        >
        <motors-summary-page-photos-media-section></motors-summary-page-photos-media-section>
      </div>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col lg="6" sm="12">
      <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
        >
        <motors-summary-page-contact-details-section></motors-summary-page-contact-details-section>
      </div>
    </tg-col>
  </tg-row>
  @if (displayAuctionSection) {
    <tg-row>
      <tg-col lg="6" sm="12">
        <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
          >
          <motors-summary-page-auction-details-section></motors-summary-page-auction-details-section>
        </div>
      </tg-col>
    </tg-row>
  }
  @if (displayClassifiedSection) {
    <tg-row>
      <tg-col lg="6" sm="12">
        <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--ruled
                "
          >
          <motors-summary-page-classified-listing-details-section></motors-summary-page-classified-listing-details-section>
        </div>
      </tg-col>
    </tg-row>
  }
  <tg-row>
    <tg-col lg="6" sm="12">
      <div
                class="
                    motors-summary-page__section
                    motors-summary-page__section--last
                    motors-summary-page__section--ruled
                "
        >
        <motors-summary-page-summary-section></motors-summary-page-summary-section>
      </div>
    </tg-col>
  </tg-row>
</div>
<motors-summary-page-validation-summary-section></motors-summary-page-validation-summary-section>
